import { mapStanceToServerInput } from './map-stance-to-server-input';

const mapDraftToServerInputs = (draft) => ({
  name: draft.name,
  // Include photoPathFace if it exists in the draft (even if null), to allow clearing photos
  ...(draft && 'photoPathFace' in draft ? { photoPathFace: draft.photoPathFace } : {}),
  issues: (draft?.issues || []).map((issue) => {
    const issueHasMissingData = issue?.missingData !== null && issue?.missingData !== undefined;
    return {
      key: issue.key,
      missingData: issue.missingData,
      stances: (issue?.stances || [])
        .filter((stance) => {
          const isMissingStanceText = typeof stance?.text === 'string'
            ? stance.text.trim() === ''
            : stance?.text === null || stance?.text === undefined;

          // If the issue has missingData set, drop stances with no text.
          return !(issueHasMissingData && isMissingStanceText);
        })
        .map(mapStanceToServerInput)
    };
  }),
  bios: (draft.bios || []).map(bio => ({
    ...bio,
    text: bio?.missingData ? '' : bio?.text,
    sources: (bio?.sources || []).filter(s => s.url !== ''),
  })),
  references: draft.references,
  ...(draft && 'removedAutoContent' in draft
    ? { removedAutoContent: draft.removedAutoContent }
    : {}),
});

export { mapDraftToServerInputs };
